export const environment = {
  production: true,
  baseUrl: "https://ai-kharkov-dynabic-com--site.new.k8s.dynabic.com" // "https://ai.kharkov.dynabic.com"
};
